export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const LOAD_LOGIN = 'LOAD_LOGIN'

export const SET_MESSAGE = 'SET_MESSAGE'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'

export const SET_PROVINCES = 'SET_PROVINCES'
export const SET_CHANGE = 'set'

export const SET_CHANNEL_OPTIONS = 'SET_CHANNEL_OPTIONS'
export const LOAD_CHANNEL_OPTIONS = 'LOAD_CHANNEL_OPTIONS'

export const GET_RULES = 'GET_RULES'
